import { ALERTS_PERMISSION_KEY } from '@/shared/config'

/** Leaf under the shell-owned Cockpit group. */
export const alertNavItems = [
  {
    labelKey: 'alerts.nav.label',
    to: { name: 'Alerts' },
    navKey: 'alerts',
    visibility: { control: 'permission' as const, id: [ALERTS_PERMISSION_KEY] },
  },
]
